<style scoped>
.grid-item {
  border: solid 1px;
  cursor: pointer;
}
.clear-left {
  clear: left;
}
.timeline-wrapper {
  line-height: 50px;
}
.timeline-content {
  overflow: hidden;
}
</style>

<template>
  <div class="display-flex">
    <div class="chart" :style="styleGridLayout">
      <div class="full-width">
        <div v-for="(val, index) in durationInterval" :style="styleTimelineItem" :key="index">| {{stringTimeFormatter(val)}}
        </div>
        <div class="clear-left" />
      </div>
      <grid-layout
        v-if="duration"
        :style="styleGridLayout"
        :layout="data"
        :col-num="duration"
        :row-height="rowHeight"
        :maxRows="99"
        :autoSize="true"
        :is-draggable="true"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="false"
        :use-css-transforms="true"
        @layout-updated="onUpdateLayout"
        >
        <grid-item
          class="grid-item"
          v-for="(item, index) in data"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :minH="1"
          :maxH="1"
          :maxW="duration"
          dragAllowFrom=".drag-handle"
          :key="index"
          >
          <div class="timeline-wrapper full-width full-height vertical-align-middle display-flex" @click="onClickListItem(index)">
            <span class="drag-handle"><mu-icon value="open_with"></mu-icon></span>
            <div class="timeline-content text-align-center flex-item" v-tooltip="stringTimeFormatter(item.x) + ' - ' + stringTimeFormatter(item.x + item.w)">
              {{item.content}}
            </div>
            <a href="#" @click.stop.prevent="onDeleteListItem(index)" v-tooltip="$t('button.delete')">
              <mu-icon value="delete" color="secondary"></mu-icon>
            </a>
          </div>
        </grid-item>
      </grid-layout>
    </div>
  </div>
</template>

<script>
// Library
import { GridLayout, GridItem } from "vue-grid-layout";

export default {
  name: "TimelineEditor",
  components: {
  GridLayout,
  GridItem
  },
  props: {
  mediaId: {
    type: String,
    required: true
  },
  duration: {
    type: Number,
    default: 999
  },
  initData: {
    type: Array,
    required: true
  },
  widthGridLayout: {
    type: Number
  }
  },
  data() {
  return {
    // Object
    data: this.initData,

    // Constant
    rowHeight: 50
  };
  },
  computed: {
  styleGridLayout() {
    return {
    width: this.widthGridLayout + "px"
    };
  },
  durationInterval() {
    var array = [];
    var i = 0;
    for (i = 0; i < this.duration - 5; i += 5) {
    array.push(i);
    }
    return array;
  },

  styleTimelineItem() {
    return {
    width: Math.floor(this.widthGridLayout / this.duration * 5 - 10) + "px",
    float: "left",
    "margin-left": "10px"
    };
  },
  styleOverlayItem() {
    return {
    height: this.rowHeight + "px",
    "margin-top": "10px",
    "line-height": this.rowHeight + "px"
    };
  }
  },
  watch: {
  initData() {
    this.data = this.initData;
  }
  },
  methods: {
  stringTimeFormatter(sec) {
    var sec_num = parseInt(sec, 10); // don't forget the second param
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
    hours = "0" + hours;
    }
    if (minutes < 10) {
    minutes = "0" + minutes;
    }
    if (seconds < 10) {
    seconds = "0" + seconds;
    }
    if (hours <= 0) {
    return minutes + ":" + seconds;
    } else {
    return hours + ":" + minutes + ":" + seconds;
    }
  },

  // Event
  onUpdateLayout(newLayout) {
    this.$emit("onUpdateLayout", newLayout);
  },
  onClickListItem(index) {
    this.$emit("onClickListItem", index);
  },
  onDeleteListItem(item) {
    this.$emit("onDeleteListItem", item);
  },

  // Class
  classOverlayItem(index) {
    return {
    "md-primary": index == this.indexSelected
    };
  }
  }
};
</script>
